import { render, staticRenderFns } from "./biaoti.vue?vue&type=template&id=5a7cc560&"
import script from "./biaoti.vue?vue&type=script&lang=ts&"
export * from "./biaoti.vue?vue&type=script&lang=ts&"
import style0 from "./biaoti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports